export const SOURCE_STATUSES: { id: string; display_name: string }[] = [
  { id: "adopted", display_name: "Adopted" },
  { id: "draft", display_name: "Emerging" },
];
